var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',[_c('v-col',{staticClass:"text-center white--text",attrs:{"cols":"12"}},[_vm._v("© Телефония "+_vm._s(new Date().getFullYear()))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }